/** A read-only labelled value on the staff detail page. */
export default function StaffDisplayField({
  label,
  value,
}: {
  label: string;
  value: React.ReactNode;
}) {
  return (
    <div>
      <p className="block text-xs text-stone-500 dark:text-stone-400 mb-1">{label}</p>
      <p className="text-sm text-bark-900 dark:text-stone-100">
        {value || <span className="text-stone-400">—</span>}
      </p>
    </div>
  );
}
